import {type AvailableLanguages, getLanguage} from "../utils/i18n";
import {HIDDEN_FIELD_NAME} from "../utils/constants";
import {data} from "@@context";
import {translateError} from "../utils/error";

export function getTokenFromSolution(el: Element, solution: string): string {
    if (!solution) {
        return '';
    }
    return `v=1&lang=${getLanguage(el)}|${solution}`
}

export function createPowInput(value = ''): HTMLInputElement {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = HIDDEN_FIELD_NAME;
    input.value = value;
    return input;
}

export function getErrorMessage(lang: AvailableLanguages): string | undefined {
    const errorId = data.errorId;
    if (!errorId) {
        return undefined;
    }
    return translateError(lang, errorId, data.errorMsg)
}
